import * as React from "react";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const LoginPage = () => {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-slate-700 bg-slate-800/50 backdrop-blur">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-20 h-20 rounded-full overflow-hidden shadow-lg ring-4 ring-indigo-500/30">
            <img 
              src="/endavant-logo.jpg" 
              alt="Endavant Logo" 
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <CardTitle className="text-2xl text-white">Datahub by Endavant</CardTitle>
            <CardDescription className="text-slate-400 mt-2">
              Plataforma de monitoreo y análisis de datos
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="text-center text-sm text-slate-400">
            <p>Acceso exclusivo para miembros de:</p>
            <div className="mt-2 flex flex-wrap justify-center gap-2">
              <span className="px-2 py-1 bg-slate-700/50 rounded text-slate-300 text-xs">
                @latamdigitalmarketing.com
              </span>
              <span className="px-2 py-1 bg-slate-700/50 rounded text-slate-300 text-xs">
                @endavantgroup.com
              </span>
              <span className="px-2 py-1 bg-slate-700/50 rounded text-slate-300 text-xs">
                @perform-ly.com
              </span>
              <span className="px-2 py-1 bg-slate-700/50 rounded text-slate-300 text-xs">
                @ldm.gg
              </span>
            </div>
          </div>
          
          <Button 
            onClick={handleGoogleLogin}
            className="w-full h-12 bg-white hover:bg-gray-100 text-gray-800 font-medium flex items-center justify-center gap-3"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Iniciar sesión con Google
          </Button>
          
          <p className="text-center text-xs text-slate-500">
            Tu email debe estar autorizado para acceder. Si no tienes acceso, contacta al administrador.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
